import React, { useState, useEffect, useRef } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, FormHelperText } from '@material-ui/core'
import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import DialogLoader from '../../../components/Loader/DialogLoader';
import { InputBaseField, CheckboxField, TextareaField } from '../../../components/InputField/InputField';
import { Label } from '../../../components/UiElements/UiElements'
import { GetUserInfo } from "../../../Services/GetUserInfo";
import { PostDataAPI } from '../../../Services/APIService';
import { withSnackbar } from "./../../../components/Message/Alert";
import { ActionDialog } from "./../../../components/ActionDialog/ActionDialog";
import { formateMdnNumber, validatePhoneNumber, handleNumberKeyPress, validateEmail, allowedAttachments, saveActivlityLogInfo } from '../../../../src/components/Common/Extensions';
import AttachmentIcon from '@material-ui/icons/Attachment';
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';
import profilePlaceholder from './../../../assets/img/profilePlaceholder.jpg';
import EditPen from './../../../assets/img/icons/pen-Regular.svg';


function AddContact({ addressType, dialogOpenClose, handleClose, handleSuccessClose, accountNumber, objAddress, accountPhoneNumber, ...props }) {

    const classes = useStyles();
    const { showMessage } = props;
    const commonAttachments = allowedAttachments();
    const [errorMessages, setErrorMessages] = useState({ accountNumber: accountNumber });
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        accountNumber: accountNumber
    });
    const [profileImage, setProfileImage] = useState({ file: null, fileToSend: null, fileName: null });
    const inputFile = useRef(null);

    const onButtonClick = () => {
        inputFile.current.click();
    };
    const convertBytesToMegabytes = (bytes) => {
        return (bytes / (1024 * 1024)).toFixed(2);
    };
    function uploadSingleFile(e) {

        const file = e.target.files[0];
        if (file == null || file <= 0)
            return;
        const fileSize = convertBytesToMegabytes(file.size);
        if (fileSize > 10) {
            showMessage("Error", "File size must be less than 10 MB", "error", 3000);
            return;
        }
        const name = file.name;
        const lastDot = name.lastIndexOf('.');
        const fileName = name.substring(0, lastDot);
        const ext = name.substring(lastDot + 1);
        switch (ext) {
            case commonAttachments[ext]:
                break;
            default:
                showMessage("Error", "File format is not allowed,\n Only files with the following extensions are allowed: .png .jpg .jpeg", "error", 3000);
                return;
        }
        setProfileImage({
            file: URL.createObjectURL(file),
            fileToSend: file,
            fileName: file.name
        })
    }

    //action dialog 
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    });
    let user_info = JSON.parse(GetUserInfo());
    const [customerID] = useState(user_info.user.customerID);
    const getContactName = (contact) => {
        return contact?.firstName || contact?.emailAddress || contact?.phoneNumber || "selected contact";
    };
    const getContactSummary = (contact) => {
        const details = [`notify contact ${getContactName(contact)}`];
        if (contact?.phoneNumber)
            details.push(`phone ${contact.phoneNumber}`);
        if (contact?.emailAddress)
            details.push(`email ${contact.emailAddress}`);
        return details.join(", ");
    };
    const logNotifyContactActivity = (activity, actionText, contact = state) => {
        saveActivlityLogInfo(
            "Notify Contacts",
            activity,
            `User ${actionText} ${getContactSummary(contact)}`,
            accountNumber,
            customerID
        );
    };
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }

    const activateCloseDialog = () => {
        setErrorMessages({})
        handleClose()
    }

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }

    const handleCheckChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };

    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }
    const Validate = (errorList) => {
        if (!state.firstName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorFirstName: false
            }));
        }
        if (!state.phoneNumber) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhone: false
            }));
        }
        if (state.phoneNumber && !validatePhoneNumber(state.phoneNumber)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }
        if (!state.emailAddress) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.emailAddress && !validateEmail(state.emailAddress)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidEmailAddress: false
            }));
        }
    }

    const deleteCustomerContact = () => {
        logNotifyContactActivity("Delete Confirmation Opened", "opened delete confirmation for");
        showActionDialog("Are you sure you want to delete this contact?", "confirm", function () {
            setIsLoading(true);
            var method = "customer/deleteCustomerContact";
            state.accountPhoneNumber = accountPhoneNumber;
            PostDataAPI(method, state, true).then((result) => {
                if (result.success && result.data != null) {
                    logNotifyContactActivity("Contact Deleted", "deleted");
                    handleSuccessClose("Record deleted successfully");
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
                setIsLoading(false);
            });
        });

    }

    const saveCustomerContact = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            var method = "customer/addCustomerContact";
            if (state.contactId > 0) {
                method = "customer/updateCustomerContact";
            }

            const formData = new FormData();
            state.accountPhoneNumber = accountPhoneNumber;
            for (var key in state) {
                if (state[key] && key != "fileName" && key != "formFile" && key != "encUserID")
                    formData.append(key, state[key]);
            }

            formData.append("formFile", profileImage.fileToSend);
            formData.append("fileName", profileImage.fileName);


            PostDataAPI(method, formData, true, "formData").then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    if (state.contactId > 0) {
                        handleSuccessClose("Record updated successfully");
                    } else {
                        handleSuccessClose("Record added successfully");
                    }
                    
                }
                else {
                    showMessage("Error", result.message, "error", 3000);
                }
               
            });
        }

    }

    const ImageSelected = useRef(null);

    const uploadFile = () => {

        ImageSelected.current.click();
    };

    useEffect(() => {
        if (objAddress.contactId > 0) {

            setState(objAddress);
        }

        setErrorMessages({});
    }, []);
    return (
        <>
            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableBackdropClick
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="lg"
                {...props} >
                <div className={classes.dialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>{state.contactId > 0 ? 'Edit Contact' : 'Add Contact'}</Typography>
                            <Icon className={classes.closeIcon} onClick={activateCloseDialog} color="primary"><CloseIcon /></Icon>
                        </div>

                        <div className={classes.content}>

                            <Grid row>
                                
                                <div  className={classes.uploadImageLabel}>
                                    
                                    {profileImage.file || state.photoPath ?
                                        <img id='profileImgSource' src={profileImage.file != null ? profileImage.file : "." + state.photoPath} className='profile-image-address'/>
                                        : <img src={profilePlaceholder} className='profile-image-address' />
                                    }
                                    
                                    <img className={classes.EditICon} src={EditPen} onClick={uploadFile}/>


                                    <input style={{ visibility: 'hidden' }} type="file" ref={ImageSelected} id="fileUploadField" className={classes.inputFile} onChange={uploadSingleFile} accept=".png, .jpg, .jpeg" />

                                </div>
                            </Grid>
                           
                            <Grid row>
                                <Label title="Name" size={24} mandatory={true} />
                                <Grid lg={12} md={12} sm={12} xl={12}>
                                    <InputBaseField
                                        name="firstName"
                                        placeholder="Name"
                                        type="text"
                                        value={state.firstName}
                                        onChange={handleChange}
                                        MaxLength={50}
                                    />
                                    {errorMessages.errorFirstName && !state.firstName ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter name
                                    </FormHelperText>) : ('')}
                                </Grid>

                            </Grid>

                            <Grid row>
                                <Label title="Phone Number" size={24} mandatory={true} />
                                <Grid lg={12} md={12} sm={12} xl={12}>
                                    <InputBaseField
                                        name="phoneNumber"
                                        placeholder="Phone Number"
                                        type="text"
                                        value={state.phoneNumber}
                                        onChange={handlePhoneChange}
                                        MaxLength={14}
                                    />
                                    {errorMessages.errorPhone && !state.phoneNumber ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter phone number
                                    </FormHelperText>) : ('')}
                                    {errorMessages.errorInvalidPhone && state.phoneNumber && !validatePhoneNumber(state.phoneNumber) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid phone number
                                    </FormHelperText>) : ('')}
                                </Grid>

                            </Grid>

                            <Grid row>
                                <Label title="Email Address" size={24} mandatory={true} />
                                <Grid lg={12} md={12} sm={12} xl={12}>
                                    <InputBaseField
                                        name="emailAddress"
                                        placeholder="Email Address"
                                        type="email"
                                        value={state.emailAddress}
                                        onChange={handleChange}
                                        MaxLength={80}
                                    />
                                    {errorMessages.errorEmailAddress && !state.emailAddress ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter email address
                                    </FormHelperText>) : ('')}
                                    {errorMessages.errorInvalidEmailAddress && state.emailAddress && !validateEmail(state.emailAddress) ? (<FormHelperText style={{ color: "red" }} >
                                        Please enter valid email address
                                    </FormHelperText>) : ('')}
                                </Grid>

                            </Grid>

                        

                            {/* <Grid row>
                                <Grid item lg={12}>
                                    <CheckboxField
                                        color="primary"
                                        name="isFavourite"
                                        label="Add to Favorite"
                                        checked={state.isFavourite}
                                        onChange={handleCheckChange}
                                    />
                                </Grid>
                            </Grid> */}

                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={activateCloseDialog}>Close</Button>
                                {state.contactId > 0 ? <Button className={classes.deleteBtn} onClick={deleteCustomerContact}>Delete</Button> : ''}

                                <Button className={classes.changeBtn} onClick={saveCustomerContact}>Save</Button>

                            </div>
                        </div>

                    </div>
                </div>
                <ActionDialog
                    type={actiondialogState.type}
                    message={actiondialogState.message}
                    actiondialogOpenClose={actiondialogState.showHide}
                    onSubmit={actiondialogState.onClickOk}
                    onCancel={() =>
                        setActionDialogState(prevState => ({
                            ...prevState, showHide: false
                        }))
                    }
                    onClose={() => setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))

                    }
                />
            </Dialog>

        </>
    )
}

export default withSnackbar(AddContact);
